import { createUseStyles } from 'react-jss'
import { WHITE } from '@omnilert/components'

export default createUseStyles({
  button: {
    marginBottom: '25px',
    width: '100%'
  },
  icon: {
    '& path': {
      stroke: 'url(#success)'
    }
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  modalTextContainer: {
    '& > div': {
      marginBottom: '10px',
      padding: '5px'
    },
    alignItems: 'center',
    color: WHITE,
    display: 'flex',
    flexDirection: 'column',
    margin: '15px 0',
    textAlign: 'center'
  }
})

